export default {
  setDate: (context, payload) => {
    context.commit('setDate', payload);
  },
}
